<template>
  <Toast/>
  <DialogConfirmation ref="dialogConfirmation"/>
  <div class="row">
    <div class="col">
      <DataTable showGridlines
                 class="p-datatable-sm"
                 :value="localisations"
                 :resizableColumns="true"
                 columnResizeMode="fit"
                 :reorderableColumns="true"
                 dataKey="cleLocalisation"
                 :paginator="true"
                 :rows="10"
                 sort-field="localisations"
                 :sortOrder="-1"
                 paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                 :rowsPerPageOptions="[10, 30, 100]"
                 currentPageReportTemplate="Afficher {first} de {last} sur {totalRecords} localisations"
      >
        <template #empty>
          <div v-if="isRechercheDataLoading == true" class="row">
            <div class="col">
              <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
            </div>
          </div>
          <div v-else class="row">
            &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
          </div>
        </template>
        <Column
            field="cleLocalisation"
            header="Clé"
            :sortable="true"
        ></Column>
        <Column
            field="entiteDescription"
            header="Entité"
            :sortable="true"
        ></Column>
        <Column field="cleSite" header="Site" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <Dropdown class="dropdown-height"
                          v-model="data[field]"
                          :options="onChangeEntity(data.cleEntite)"
                          optionValue="valeur"
                          optionLabel="texte"
                          scrollHeight="205px"
                          :showClear="true"/>
              </div>
            </div>
          </template>
        </Column>
        <Column field="locationDescription" header="Localisation" :sortable="true">
          <template #body="{ data, field }">
            <div class="row">
              <div class="col">
                <InputText v-model="data[field]"/>
              </div>
            </div>
          </template>
        </Column>
        <Column headerStyle="width: 8rem" :exportable="false">
          <template #body="slotProps">
            <div class="row">
              <div class="col">
                <Button
                    icon="pi pi-save"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="sauvegarder(slotProps.data)"
                />
              </div>
              <div class="col">
                <Button
                    icon="pi pi-trash"
                    class="p-button-datatable p-button-rounded-sm"
                    @click="confirmerSuppression(slotProps.data)"
                />
              </div>
            </div>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";
import axios from 'axios';
import DialogConfirmation from '../../../Commun/DialogConfirmation.vue';

export default {
  props: ['localisations', 'isRechercheDataLoading'],
  emits: ['removeLocalisationFromList'],
  components: {
    DialogConfirmation
  },
  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
          this.entiteLibelles = res.data.entiteDecision.entite.libelles;

          for (let i = 0; i < this.entiteLibelles.length; i++) {
            this.$store.dispatch('dossier/onChangeEntityAction', {
              libelleChange: 'Site',
              nouvelleValeur: [this.entiteLibelles[i].valeur]
            })
                .then((res) => {
                  this.siteLibelles = res.data;
                  this.siteLibellesParEntite.push({
                    entite: this.entiteLibelles[i].valeur,
                    libelles: this.siteLibelles
                  });
                });
          }
        });
  },
  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },
  data() {
    return {
      localisationToDelete: {},
      entiteLibelles: [],
      siteLibelles: [],
      siteLibellesParEntite: [{
        entite: null,
        libelles: []
      }],
    }
  },
  methods: {
    confirmerSuppression(data) {
      this.localisationToDelete = {
        cleLocalisation: data.cleLocalisation, cleEntite: data.cleEntite, entiteDescription: data.entiteDescription,
        cleSite: data.cleSite, siteDescription: data.siteDescription, locationDescription: data.locationDescription
      };
      this.$confirm.require({
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        message: "Voulez-vous supprimer la localisation?",
        accept: () => {
          return this.supprimer();
        },
        reject: () => {
        },
      })
    },
    supprimer() {
      this.$store.dispatch('pilotage/supprimerLocalisationAction', {localisationCompletVO: this.localisationToDelete})
          .then((res) => {
            if (res?.data?.messageVOs.length == 0) {
              this.$toast.add({
                severity: 'success',
                summary: 'Suppression Localisation',
                detail: "La suppression a été effectuée",
                life: 6000
              });
              this.$emit("removeLocalisationFromList", this.localisationToDelete.cleLocalisation);
            } else {
              this.$root.$refs.messagesComp.messagesList = res.data.messageVOs;
            }
          });
    },
    sauvegarder(data) {
      let localisationCompletVO = {
        cleLocalisation: data.cleLocalisation, cleEntite: data.cleEntite, entiteDescription: data.entiteDescription,
        cleSite: data.cleSite, siteDescription: data.siteDescription, locationDescription: data.locationDescription
      };
      this.$store.dispatch('pilotage/modifierLocalisationAction', {localisationCompletVO: localisationCompletVO}).then(() => {
        this.$toast.add({
          severity: 'success',
          summary: 'Modification Localisation',
          detail: 'La modification a été effectuée',
          life: 6000
        });
      });
    },
    onChangeEntity(val) {
      for (let i = 0; i < this.siteLibellesParEntite.length; i++) {
        if (this.siteLibellesParEntite[i].entite == val) {
          return this.siteLibellesParEntite[i].libelles;
        }
      }
    }
  },
};
</script>
